import { Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, style, transition, animate } from '@angular/animations';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subscription, of, concat, forkJoin } from 'rxjs';
import { finalize, tap, catchError, concatMap } from 'rxjs/operators';
import { DebtorsStatusEnum, debtorTipo, debtordocumenttype } from 'src/app/_enums';
import { BatchProcessUrls } from 'src/app/_enums/urls';
import { AppConfig, DataService, ExcelService, ParameterData, PreviousRouteService } from 'src/app/_helpers';
import { DebtorsPatchRequest, ICustomer, QueryParamsCustomerList } from 'src/app/_models';
import { AuthService, BackFilterService, CustomerService, DebtorService, ExcelDateConvertService, PreloadService } from 'src/app/_services';
import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-new-customer-company-list',
  templateUrl: './new-customer-list.component.html',
  styleUrls: [
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-customer-list-table.css',
    '../../../../sharedcomp/sidebar/sidebar.component.css',
    '../../../../sharedcomp/ui-components/drpdowns/dropdown/dropdown.component.css',
    '../../../../../assets/css/new-buttons-theme.css',
    './new-customer-list.component.css'
],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ])
  ]
})
export class NewCustomerCompanyListComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  excelExportData: any;
  ddldbtTipo: any[];
  ddldbdocumenttype: any[];

  auth0Profile: any;

  searchFilterForm: FormGroup;
  displayedColumns: string[] = ['select', 'name', 'created', 'document_id', 'phone', 'status', 'actions'];
  dataSource = new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  public iCustomer: ICustomer;
  debtorsPatchRequest: DebtorsPatchRequest[] = [];
  pageSize: number;
  PageSizeOptions: number[];
  isadmin = false;
  paginatorIntl: any;
  isImport = false;
  customerStatus = 0;
  customerType = 0;
  searchValue = '';
  pageIndex: number = 0;
  pageStart: number = 0;
  totalSize: any = 0;
  isExportExcelAvailable = true;
  isImportAvailable = true;
  isCreateAvailable = true;
  isUpdateAvailable = true;
  isMassiveToggleStatusAvailable = true;
  backToSearch: any;
  tempSearch: any;
  previousUrl: any;
  filterType = new FormControl(0);
  filterStatus = new FormControl('TODOS');
  isBrowserBackButtonPressed: boolean = false;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  queryParams: QueryParamsCustomerList = {};
  snapshotQueryParam: QueryParamsCustomerList = {};

  timerId: any;
  isExportDataAvailable:  undefined | any;
  isErrorExportAvailable: object | undefined;
  timeCompleted: boolean = false;
  exportSubscription$ : Subscription;
  baseURL: string;

  isSidebarVisible: boolean = false;
  icons: Record<string, Record<string, string>>;
  images = [];
  preloadImages = ["../../../../../assets/new-icons/user-icon.svg", "../../../../../assets/new-icons/blue-plus-icon.svg", "../../../../../assets/new-icons/filter-lines.svg"]
  displayLoaderSpinner: boolean = false;
  ShowTypesOfClients: boolean = false;

  selection = new SelectionModel<any>(true, []);

  isTableLoading: boolean = false;

  constructor (
      private customerService: CustomerService
      , private formBuilder: FormBuilder
      , private excelService: ExcelService
      , private parameterData: ParameterData
      , private router: Router
      , private debtorService: DebtorService
      , private ddldebtorTipo: debtorTipo
      , private documentType: debtordocumenttype
      , private dataService: DataService
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private backFilterService: BackFilterService
      , private previousRouteService: PreviousRouteService
      , private excelDateConvertService:ExcelDateConvertService
      , private activatedRoute: ActivatedRoute
      , private renderer: Renderer2
      , private preloadService: PreloadService
  ) {
    this.spinnerService.show();
    this.icons = icons;
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.ddldbdocumenttype = documentType.documenttype;
    this.ddldbtTipo = ddldebtorTipo.dbtTipo;
    this.isadmin = false;
    this.isImport = false;
    this.backFilterService.getCustomerSearchSharedData().subscribe(data => this.backToSearch = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
    this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V2;
    this.initSearchForm();
  }

  ngOnInit() {
    let country = localStorage.getItem('country');
    if(country === 'PE'){
      this.ShowTypesOfClients = true;
    }
    this.checkThisPageGrants();
    this.images = this.preloadService.preloadImages(this.preloadImages, this.images);
    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }

    //back to search start
    this.previousUrl = this.previousRouteService.getPreviousUrl();
    if ((this.isBrowserBackButtonPressed == true) &&
      this.previousUrl != undefined &&
      (this.previousUrl.includes("/customers/")) &&
      (this.previousUrl.includes("/edit") || this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    } else {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setCustomerSearchSharedData(null);
    }
    // back to search end

    this.getCustomerDetails(this.customer_public_id, this.customerStatus, this.customerType, this.pageSize, this.pageStart, this.searchValue);
  }

  toggleDropdown(option: string) {
    this.filterStatus.patchValue(option);
    this.filterStatusDetails(option);
  }

  get filterTypeName(): string {
    const filterType = this.ddldbtTipo.find(item => item.value === this.filterType.value);
    return filterType ? filterType.name : '';
  }

  selectTypeOption(option: string) {
    this.filterType.patchValue(option);
    this.filterCompanyDetails(option);
  }

  selectActionOption(option: number) {
    const selectedElements = Array.from(this.selection.selected);

    if (selectedElements.length === 0) {
      return;
    }

    this.isTableLoading = true;
    const newStatus = option === 1 ? DebtorsStatusEnum.STATUS : DebtorsStatusEnum.INACTIVETEXT;
    const statusValue = { "status": newStatus };

    const updateOperations = selectedElements.map(element => 
      this.debtorService.updateDebtor(element.public_id, JSON.stringify(statusValue))
        .pipe(
          tap(data => {
            element.status = data.body.status;
          }),
          catchError(error => {
            console.error('Failed while trying to update debtor status. ' + error);
            return of(null);
          })
        )
    );

    forkJoin(updateOperations).pipe(
      finalize(() => {
        // Get updated list only once after all updates are complete
        this.customerService.getCustomerList(
          this.customer_public_id, 
          this.customerStatus, 
          this.customerType, 
          this.pageSize, 
          0, 
          this.searchValue
        ).subscribe(
          data => {
            let resources = data["body"]["data"];
            this.totalSize = data["body"]["records"];
            this.dataSource.data = resources;
            this.clearSelection();
            this.isTableLoading = false;
          },
          error => {
            console.error('Failed while trying to update customers. ' + error);
            this.isTableLoading = false;
            this.clearSelection();
          }
        );
      })
    ).subscribe();
  }

  /**
   * Clears all selected rows in the table
   */
  clearSelection() {
    this.selection.clear();
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
  }

  selectStatusOption(option: string) {
    this.filterStatus.patchValue(option);
    this.filterStatusDetails(option);
  }

  initSearchForm() {
    this.searchFilterForm = new FormGroup({
      searchText: new FormControl(this.searchValue, [Validators.required])
   });
  }

  applyFilter() {
    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();

    let filterVal = this.filterValue.split(':')[0];
    filterVal = filterVal.trim();
    if (filterVal == 'DNI' || filterVal == 'RUC' || filterVal == 'CEX' || filterVal == 'OTROS') {
      this.searchValue = this.filterValue.split(':')[1].trim();;
    }
    else {
      this.searchValue = this.filterValue;
    }
    this.setBackToSearchFilter();
    this.getCustomerListFilterAndSearch(this.customerStatus, this.customerType, this.searchValue);
  }

  cancelCreation(cancel: boolean) {
    if (!cancel) {
      this.isSidebarVisible = cancel;
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  openCreateCustomerSidebar() {
    this.renderer.addClass(document.body, 'modal-open');
    this.isSidebarVisible = true;
  }

  setBackToSearchData() {
    if (this.backToSearch != null) {
      this.searchValue = this.backToSearch.search;
      this.customerType = this.backToSearch.type;
      this.customerStatus = this.backToSearch.status;
      this.pageSize = this.backToSearch.pageSize;
      this.pageIndex = this.backToSearch.pageIndex;
      this.pageStart = this.backToSearch.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      //set type dropdown value
      this.filterType.setValue(this.customerType);
      //set status dropdown value
      if (this.customerStatus == 1) {
        this.filterStatus.setValue('Activos')
      } else if (this.customerStatus == 2) {
        this.filterStatus.setValue('Inactivos')
      } else {
        this.filterStatus.setValue('TODOS')
      }
      this.setBackToSearchFilter();
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  getCustomerDetails(public_id: string, status: number, type: number, limit: number, start: number, search: string) {
    this.displayLoaderSpinner = true;
    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {

        if (this.snapshotQueryParam["pageIndex"] != undefined) {
          if(this.snapshotQueryParam["pageIndex"] != ''){
            this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
          } else {
            this.queryParams.pageIndex = this.pageIndex;
          }
        };

        if (this.snapshotQueryParam["pageSize"] != undefined) {
          if(this.snapshotQueryParam["pageSize"] != '') {
            this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
          } else {
            this.queryParams.pageSize = this.pageSize;
          }
        };

        if (this.snapshotQueryParam["type"] != undefined) {
          this.queryParams.type = this.snapshotQueryParam["type"];
          this.setTypeFormBySnapshotQueryParam((this.queryParams.type).toString());
        };

        if (this.snapshotQueryParam["status"] != undefined) {
          this.queryParams.status = this.snapshotQueryParam["status"];
          this.setStatusFormBySnapshotQueryParam((this.queryParams.status).toString());
        };

        if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
          this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
          this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
        };

        this.pageEvent(this.queryParams);
    } else {
      this.customerService.getCustomerList(public_id, status, type, limit, start, search).subscribe(data => {
        let resources = data["body"]["data"];
        this.totalSize = data["body"]["records"];
        this.dataSource.data = resources;
        this.displayLoaderSpinner = false;
        this.spinnerService.hide();
      },
        error => {
          console.error('Failed while trying to the Customer Search Result. ' + error);
        })
    };
  }

  setTypeFormBySnapshotQueryParam(status: string) {
    switch (status) {
      case '0':
        this.filterType.setValue(0);
        break;
      case '1':
        this.filterType.setValue(1);
        break;
      case '2':
        this.filterType.setValue(2);
        break;
      default:
        this.filterType.setValue(0);
    }
  }

  setStatusFormBySnapshotQueryParam(status: string) {
    switch (status) {
      case '0':
        this.filterStatus.setValue('TODOS');
        break;
      case '1':
        this.filterStatus.setValue('Activos');
        break;
      case '2':
        this.filterStatus.setValue('Inactivos');
        break;
      default:
        this.filterStatus.setValue('TODOS');
    }
  }

  pageEvent(event) {
    this.displayLoaderSpinner = true;
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if (event["status"]) {
      this.queryParams.status = event["status"];
      this.customerStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.customerStatus;
    };

    if (event["type"]) {
      this.queryParams.type = event["type"];
      this.customerType = this.queryParams.type;
    } else {
      this.queryParams.type = this.customerType;
    };

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.customerService.getCustomerList(this.customer_public_id, this.customerStatus, this.customerType, this.pageSize, this.pageStart, this.searchValue).subscribe(data => {
      let resources = data["body"]["data"];
      this.totalSize = data["body"]["records"];
      this.dataSource.data = resources;
      this.displayLoaderSpinner = false;
      this.spinnerService.hide();
    }, error => {
      this.displayLoaderSpinner = false;
      this.spinnerService.hide();
      console.error('Failed while trying to the Customer Search Result. ' + error);
    });

    this.setBackToSearchFilter();
  }

  editDebtor(element) {
    this.router.navigate([`/customers/${element.public_id}/edit`]);
  }

  setNewStatus(item) {
    return item.status === DebtorsStatusEnum.STATUS ? DebtorsStatusEnum.INACTIVETEXT : DebtorsStatusEnum.ACTIVETEXT;
  }

  setCustomerStatus(event, item) {
    event.preventDefault();
    this.spinnerService.show();
    let statusValue = {};

    const newStatus = this.setNewStatus(item);
    statusValue = {
      "adress": item.adress,
      "document_id": item.document_id,
      "document_type": item.document_type,
      "email": item.email,
      "external_id": item.external_id,
      "id": item.id,
      "name": item.name,
      "phone": item.phone,
      "status": newStatus 
    };

    this.debtorService.updateDebtor(item.public_id, JSON.stringify(statusValue))
    .pipe(
      tap(data => {
        item.status = data.body.status;
        this.getCustomerDetails(this.customer_public_id, this.customerStatus, this.customerType, this.pageSize, 0, this.searchValue);
        this.spinnerService.hide();
      }),
      catchError(error => {
        console.error('Failed while trying to the Search All Result. ' + error);
        this.spinnerService.hide();
        return of(null);
      })
    )
    .subscribe();
  }

  viewDebtorDetails(element) {
    this.router.navigate([`/customers/${element.public_id}/view`]);
  }

  filterCompanyDetails(event) {
    if (event == 0) {
      this.customerType = 0;
    }
    else if (event == 1) {
      this.customerType = 1;
    }
    else if (event == 2) {
      this.customerType = 2;
    } else {
      this.customerType = 0;
    }
    this.getCustomerListFilterAndSearch(this.customerStatus, this.customerType, this.searchValue);
    this.setBackToSearchFilter();
  }

  filterStatusDetails(event) {
    if (event == 'TODOS') {
      this.customerStatus = 0;
    }
    else if (event == 'Activos') {
      this.customerStatus = 1;
    }
    else if (event == 'Inactivos') {
      this.customerStatus = 2;
    } else {
      this.customerStatus = 0;
    }
    this.getCustomerListFilterAndSearch(this.customerStatus, this.customerType, this.searchValue);
    this.setBackToSearchFilter();
  }

  getCustomerListFilterAndSearch(status: number, type: number, searchValue: string) {
    this.pageStart = 0;
    this.pageIndex = 0;
    this.setBackToSearchFilter();
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.status = status;
    this.queryParams.type = type;
    if (searchValue != '') {
      this.queryParams.textSearch = searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.pageEvent(this.queryParams);
  }

  /**
  * this function is used to get the Document type Name.
  * input parameter is document type Id value, which is number and returns document type name
  */
  getDocumentType(idValue) {

    if (idValue == "1") {
      return "DNI";
    }
    if (idValue == "2") {
      return "RUC";
    }
    if (idValue == "3") {
      return "CEX";
    }
    if (idValue == "4") {
      return "OTROS";
    }
  }//end

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  reportExport() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;
    this.checkResponseExportTime();
    let customerStatusString = this.customerStatus.toString();
    let customerTypeString = this.customerType.toString();

    this.exportSubscription$ = this.customerService.reportExport(this.customer_public_id, customerStatusString, customerTypeString, this.searchValue).subscribe(data => {
      this.isExportDataAvailable = data;
      if (data.storage_url != undefined) {
        location.href = data.storage_url;
      } else {
        console.log(data);
      }
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      this.isErrorExportAvailable = err;
      console.error('Failed while trying to the Customer Export. ' + err.error);
    });
  }

  closeModal() {
    this.timeCompleted = false;
  };

  setExportExcelFileData(excelExportData) {
    const excelHeader = ["FECHA CREACION", "NOMBRE", "EMAIL", "DOCUMENTO", "NUMERO DOCUMENTO", "TELEFONO", "ESTADO"];

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];


      var created_temp;
      var documentid_temp;
      var document_type_temp;
      var email_temp;
      var externalid_temp;
      var name_temp;
      var phone_temp;
      var status_temp;

      columnsKeyNames = Object.keys(singleRec_temp);


      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {


        if (columnsKeyNames[i] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[i]];
        }
        if (columnsKeyNames[i] == "document_id") {
          documentid_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "document_type") {
          document_type_temp = this.getDocumentType(singleRec_temp[columnsKeyNames[i]]);
        }

        if (columnsKeyNames[i] == "email") {
          email_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "external_id") {
          externalid_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "name") {
          name_temp = singleRec_temp[columnsKeyNames[i]];
        }


        if (columnsKeyNames[i] == "phone") {
          phone_temp = singleRec_temp[columnsKeyNames[i]];
        }
        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'ACTIVE':
              status_temp = 'Activo'
              break;
            case 'INACTIVE':
              status_temp = 'Inactivo'
              break;
          }
        }
      }

      arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp), name_temp, email_temp, document_type_temp, documentid_temp, phone_temp, status_temp]);
    }

    this.excelService.generateCustomersExcelFile(excelHeader, arrFinalData, 'CustomerList', localStorage.getItem('application'));
  }

  async checkThisPageGrants() {
    await this.auth.isKashioGrantsAvailable();
    this.isExportExcelAvailable = this.auth.checkGrants('CUSTOMERS', 'EXPORT');
    this.isImportAvailable = this.auth.checkGrants('CUSTOMERS', 'IMPORT');
    this.isCreateAvailable = this.auth.checkGrants('CUSTOMERS', 'CREATE');
    this.isUpdateAvailable = this.auth.checkGrants('CUSTOMERS', 'UPDATE');
    this.isMassiveToggleStatusAvailable = this.auth.checkGrants('CUSTOMERS', 'MASSIVE-TOGGLE-STATUS');
    
    // Base columns that are always shown
    const baseColumns = ['name', 'created', 'document_id', 'phone', 'status'];
    
    // Add select column if massive toggle status is available
    if (this.isMassiveToggleStatusAvailable) {
      baseColumns.unshift('select');
    }
    
    // Add actions column if update is available
    if (this.isUpdateAvailable) {
      baseColumns.push('actions');
    }
    
    this.displayedColumns = baseColumns;
  }

  setBackToSearchFilter() {
    this.tempSearch = {
      search: this.searchValue,
      type: this.customerType,
      status: this.customerStatus,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setCustomerSearchSharedData(this.tempSearch);
  }

  goTo(element) {
    this.router.navigate(['/customers', element.public_id, 'view']);
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

}
